const t = "_content_4h017_1", i = "_header_4h017_10", n = "_withEntityIndicator_4h017_10", e = "_withDivider_4h017_15", h = {
  content: t,
  header: i,
  withEntityIndicator: n,
  withDivider: e
};
export {
  t as content,
  h as default,
  i as header,
  e as withDivider,
  n as withEntityIndicator
};
//# sourceMappingURL=index.es2436.js.map
